import { isLocal } from '@/lib/hostname'

export type SkipReason = 'localHost' | 'privacySignal'

interface PrivacySignals {
  doNotTrack?: string | null
  globalPrivacyControl?: boolean
}

export function resolveSkipReason(
  hostname: string,
  signals: PrivacySignals,
): SkipReason | null {
  if (isLocal(hostname)) return 'localHost'
  const doNotTrack = signals.doNotTrack === '1' || signals.doNotTrack === 'yes'
  if (doNotTrack || signals.globalPrivacyControl === true) {
    return 'privacySignal'
  }
  return null
}
